/**
 * Shared constants for workflow container layout.
 * These values are used across multiple files to ensure consistent spacing
 * between the container node and its embedded workflow nodes.
 */

export const WORKFLOW_CONTAINER_HEADER_HEIGHT = 55;
export const WORKFLOW_CONTAINER_PADDING = 20;

